import React from 'react';
import styled from 'styled-components';

import { ALL_BADGES } from '../constants/badges';

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;

  @media (max-width: 768px) {
    justify-content: center;
  }
`;

const Badge = styled.img`
  width: 125px;
  margin: 0 20px 20px 0;
`;

export default function Badges({ badges = [] }) {
  if (badges.length < 1) {
    return null;
  }
  return (
    <Wrapper>
      {badges.map(id => {
        return <Badge src={ALL_BADGES[id].image} key={id} />;
      })}
    </Wrapper>
  );
}
